import {
    RECEIVE_HISTORY_MODEL,
    MAX_HISTORY_MODEL,
    MaxHistoryAction,
    ReceiveModelHistoryAction,
} from '../actions/ModelHistory';
import { Model } from '../../features/models/types/model';

type UWDataActionType = ReceiveModelHistoryAction | MaxHistoryAction;
export type HistoryState = {
    byID: Record<number, ModelHistory>;
    receivedAt?: number;
    fetching: boolean;
};

export type ModelHistory = {
    list: Model[];
    fetching: boolean;
    maxHistory: number | null;
};

const defaultState = {
    byID: {},
    fetching: true,
};

export default function Models(state: HistoryState = defaultState, action: UWDataActionType) {
    switch (action.type) {
        case RECEIVE_HISTORY_MODEL: {
            const { data } = action;
            const list = [...(state.byID[data.modelId]?.list ?? []), data];

            
            console.log('RECEIVE_HISTORY_MODEL')

            return {
                ...state,
                byID: {
                    ...state.byID,
                    [data.modelId]: { list, fetching: false, maxHistory: null },
                },
            };
        }
        case MAX_HISTORY_MODEL: {
            const { modelID, history } = action;
            const bi = { ...state.byID };
            console.log('MAX_HISTORY_MODEL')
            if (bi[modelID]) {
                bi[modelID] = { ...bi[modelID], fetching: false, maxHistory: history };
            }
            return {
                ...state,
                byID: bi,
            };
        }

        default:
            return state;
    }
}
